module.exports = __webpack_public_path__ + "img/BA864A_5D381E_644422_FBE97A-256px.2ffe1ace.png";